import ListStore from '@/store/core/ListStore';
import { action, computed, observable, override } from 'mobx';
import services from '@/api/services';
import { startDate, endDate } from '@/utils/date';
import { Taxpayers } from '@/store/types';
import { taxpayerTypes } from '@/store/mapping';
import { dateFormat, numGroup } from '@/utils/filters';
import { PageableQueryParams } from '@/types/pagination';

const defaultFilters = {
  name: '',
  tin: '',
  nameTin: '',
  createDate: '',
  createType: '',
  type: null,
  status: null,
  isExceed: false,
  startDate,
  endDate,
};

export default class TaxpayersStore extends ListStore<{
  items: Taxpayers[];
  totalSumIncome?: number;
  totalSumTax?: number;
  totalIncomeYear?: number;
  totalTaxYear?: number;
  totalDebtAll?: number;
}> {
  @override
  filters = JSON.parse(JSON.stringify(defaultFilters));
  @observable overall = {
    totalIncome: 0,
    totalTax: 0,
  };

  @override
  pageable: PageableQueryParams = {
    limit: 20,
    direction: 'DESC',
    page: 1,
    sortBy: 'createDate',
  };

  sortColumns: (keyof Taxpayers)[] = [
    'createDate',
    'name',
    'createType',
    'sumIncome',
    'sumTax',
    'incomeYear' ,
    'taxYear' ,
    'totalDebt',
    'totalSumTax',
    'totalSumIncome',
  ];

  @computed get processedData() {
    if (!this.data?.items || !this.data?.items?.length) return;
    const items: any[] = this.data.items.map((item: Taxpayers) => ({
      ...item,
      type: taxpayerTypes[item.type]?.label || '-',
      createDate: dateFormat(item.createDate, {
        format: 'DD.MM.YYYY',
        addHours: 0,
      }),
      sumIncome: numGroup(item.sumIncome),
      sumTax: numGroup(item.sumTax),
      incomeYear: numGroup(item.incomeYear),
      taxYear:numGroup(item.taxYear) ,
      totalDebt: numGroup(item.totalDebt),
      totalSumIncome: numGroup(item.totalSumIncome),
      totalSumTax: numGroup(item.totalSumTax),
    }));
    items.unshift({
      name: 'ИТОГО',
      sumIncome: this.data?.totalSumIncome?.toLocaleString('ru-RU'),
      sumTax: this.data?.totalSumTax?.toLocaleString('ru-RU'),
      incomeYear: this.data?.totalIncomeYear?.toLocaleString('ru-RU'),
      taxYear: this.data?.totalTaxYear?.toLocaleString('ru-RU'),
      totalDebt: this.data?.totalDebtAll?.toLocaleString('ru-RU'),
      isSummary: true,
    });
    return { ...this.data, items };
  }

  @action.bound async fetch() {
    this.isFetching = true;
    try {
      const {
        data: { totalIncome, totalTax, ...data },
      } = await services.platforms.getTaxpayersList(this.notFalsyParams);
      this.data = data;
      this.overall = { totalIncome, totalTax };
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }

  @action resetFilters() {
    this.filters = JSON.parse(JSON.stringify(defaultFilters));
  }
}
